import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DishServices } from "../../services";
import { Globals } from '../../../../globals';

/**
 * Generated class for the DishPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-create-observations',
    templateUrl: 'dish-create-observations.html',
})
export class DishCreateObservationsPage {

    update_state: boolean = false;
    dish_uid: string;
    dish_name: string;
    dish: any;
    observations: string = '';

    _observations: string = '';

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public dishServices: DishServices,
        public globals: Globals) {

        this.update_state = this.navParams.get('update');
        this.dish_uid = this.navParams.get('dish_uid');
        this.dish_name = this.navParams.get('dish_name');
        this._observations = this.navParams.get('observations');
        this.dish = this.navParams.get('dish');
    }

    public getInitObservations(editor: any) {
        if (editor.html) {
            this.observations = editor.html;
        }
    }

    update() {
        this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
            'observations': this.observations,
            'updated_at': new Date(),
            'updated_user': this.globals.user_name
        }).then(() => {
            if (this.update_state) {
                this.globals.GAtrackView('Dish', 'Dish - Observaciones - Update', this.globals.restaurant.email, 'Create/Update', 'Update observaciones', 'Dish', this.dish_name);
            } else {
                this.globals.GAtrackView('Dish', 'Dish - Observaciones - Create', this.globals.restaurant.email, 'Create/Update', 'Create observaciones', 'Dish', this.dish_name);
            }
            this.navCtrl.pop();
        });
    }



}


// WEBPACK FOOTER //
// ./src/pages/dish/dish-create/dish-create-observations/dish-create-observations.ts